import { render, staticRenderFns } from "./QuantityVoucherSupplierToAgent.vue?vue&type=template&id=3b860f16&scoped=true&"
import script from "./QuantityVoucherSupplierToAgent.vue?vue&type=script&lang=js&"
export * from "./QuantityVoucherSupplierToAgent.vue?vue&type=script&lang=js&"
import style0 from "./QuantityVoucherSupplierToAgent.vue?vue&type=style&index=0&id=3b860f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b860f16",
  null
  
)

export default component.exports